import {GET} from "../util";
import {enumDef} from "@/common/enumDefs";

const commonUrl = "api/common/";
const url = {
    countries: `${commonUrl}countries`,
    companycountries: `${commonUrl}companycountries/:companyType`,
    companyAndTraderTypecountries: `${commonUrl}companycountries/:companyType/:traderType`,
    legalstructures: `${commonUrl}legalstructures/:companyType/:country`,
    registercourts: `${commonUrl}registercourts`,
    industryTreeList: `${commonUrl}industries/tree`,
    currentuser: `${commonUrl}currentuser`,

    getToken: `common/getToken`,
    localeLang: `common/locale`,


};
const commonApi = {
    countries: () => {
        return GET(url.countries)
    },
    Companycountries: (companyType = enumDef.companyType.TraderCompany, traderType) => {
        let requestUrl;
        if (traderType) {
            requestUrl = url.companyAndTraderTypecountries.replace(":companyType", companyType).replace(":traderType", traderType);
        } else {
            requestUrl = url.companycountries.replace(":companyType", companyType);
        }
        return GET(requestUrl, {});
    },
    Registercourts: (country) => {
        return GET(url.registercourts + "/" + country);
    },
    Currentuser: (params = {}) => {
        return GET(url.currentuser, params);
    },
    getLegalStructures: (companyType, country) => {
        return GET(url.legalstructures.replace(":companyType", companyType).replace(":country", country));
    },
    getIndustryTreeList: () => {
        return GET(url.industryTreeList);
    },
    getToken: (params = {}) => {
        return GET(url.getToken, params);
    },
    localeLang: (params = {}) => {
        return GET(url.localeLang, params);
    },
};
export {
    commonApi
};